module.exports = __webpack_public_path__ + "assets/hiver.4491544d.svg";